import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/apm";

function init() {
  Sentry.init({
    dsn:
      "https://8c940950e9894e45b9a5c29ed94989cf@o438294.ingest.sentry.io/5402726",
    integrations: [new Integrations.Tracing()],
    tracesSampleRate: 1.0,
  });
}

function log(error) {
  Sentry.captureException(error);
}

export default {
  init,
  log,
};
